/* eslint-disable jsx-a11y/label-has-for */
import React, { useState, useEffect } from 'react';
import { PropTypes } from 'prop-types';

const STYLE_OPTIONS = [
  {
    value: 'default',
    label: 'default',
  },
  {
    value: 'americaRegular',
    label: 'America Regular',
  },
];

const DownCaret = () => (
  <div className="pointer-events-none absolute inset-y-0 right-0
  flex items-center px-2 text-gray-700 h-12 top-0"
  >
    <svg
      className="fill-current h-4 w-4"
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 20 20"
    >
      <path d="M9.293 12.95l.707.707L15.657 8l-1.414-1.414L10 10.828 5.757 6.586 4.343 8z" />
    </svg>
  </div>
);

const SELECT_CLASS = 'block appearance-none w-full bg-gray-200 border border-gray-200 text-gray-700 py-3 px-4 pr-8 rounded leading-tight focus:outline-none focus:bg-white focus:border-gray-500';

const initialState = {
  type: 'TitleLineH1',
  text: {
    en: '',
  },
  isHeadTitle: false,
  color: '#FFFFFF',
  bgColor: '#000000',
  textColor: '#000000', // used only in PS
  backgroundColor: 'transparent', // used only in PS
  textAlign: false,
  style: 'default',
};

const TitleLineH1 = ({
  activeLanguage, handlerSetComponents, components, languages, id, reusableComponent, reusableComponentSlugname, slider,
}) => {
  const isPS = process.env.APP_NAME === 'ps';
  const [state, setState] = useState(initialState);
  const [showOptions, setShowOptions] = useState(false);
  const [text, setText] = useState({ en: '' });
  const [bgColor, setBgColor] = useState();
  const [color, setColor] = useState();
  const [backgroundColor, setBackgroundColor] = useState(); // used in PS, all h1 have been saved with a wrong bg and color
  const [textColor, setTextColor] = useState(); // used in PS, all h1 have been saved with a wrong bg and color
  const [isHeadTitle, setIsHeadTitle] = useState(false);
  const [textAlign, setTextAlign] = useState(false);
  const [style, setStyle] = useState('default');

  useEffect(() => {
    if (slider) {
      setColor('#FFFFFF');
      setTextColor('#FFFFFF');
      setBgColor('transparent');
      setBackgroundColor('transparent');
    } else {
      setColor(isPS ? '#000000' : '#FFFFFF');
      setTextColor(isPS ? '#000000' : '#FFFFFF');
      setBackgroundColor(isPS ? 'transparent' : '#000000');
      setBgColor(isPS ? 'transparent' : '#000000');
    }
  }, []);

  useEffect(() => {
    const componentIndex = components.findIndex(obj => obj.id === id);
    const { component } = components[componentIndex];
    if (reusableComponent) {
      setState(reusableComponent);
      if (!component) handlerSetComponents({ component: { key: reusableComponentSlugname } }, componentIndex);
    } else {
      if (component) {
        const {
          text,
          color: currentColor,
          bgColor: currentBgColor,
          isHeadTitle: currentIsHeadTitle,
          textAlign: currentTextAlign,
          style: currentStyle,
          textColor: currentTextColor,
          backgroundColor: currentBackgroundColor,
        } = component;

        setState(component);
        setText(text);
        setIsHeadTitle(currentIsHeadTitle);
        setTextAlign(currentTextAlign);
        if (currentStyle) setStyle(currentStyle);
        if (currentColor) setColor(currentColor);
        if (currentBgColor) setBgColor(currentBgColor);
        if (currentTextColor) setTextColor(currentTextColor);
        if (currentBackgroundColor) setBackgroundColor(currentBackgroundColor);
      } else {
        const componentObj = {
          id,
          component: state,
        };

        handlerSetComponents(componentObj, componentIndex);
      }
    }
  }, [components]);

  useEffect(() => {
    const componentIndex = components.findIndex(obj => obj.id === id);
    const construction = {
      type: state.type,
      compId: state.compId || '',
      text: { ...text },
      color,
      bgColor,
      isHeadTitle,
      textAlign,
      style,
      textColor,
      backgroundColor,
    };
    handlerSetComponents({ component: construction }, componentIndex);
  }, [
    text,
    color,
    bgColor,
    isHeadTitle,
    textAlign,
    style,
    textColor,
    backgroundColor,
  ]);

  const titleChange = (e) => {
    text[activeLanguage] = e.target.value;
    setText({ ...text });
  };

  const handleColorInput = (e) => {
    const { value, name } = e.target;

    if (name === 'textColor') {
      setColor(value);
      setTextColor(value);
    } else {
      setBgColor(value);
      setBackgroundColor(value);
    }
  };

  return (
    <div className="flex justify-start flex-col text-black">
      {/* Single Form */}
      <div className="flex items-end py-4">
        <div className="w-full md:w-full md:mb-0">
          <label
            className="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2"
            htmlFor="grid-first-name"
          >
            Title
          </label>
          <input
            className="appearance-none block
            bg-gray-200 text-gray-700 border border-red-500
            rounded py-3 px-4 w-full leading-tight focus:outline-none
            focus:bg-white"
            id="grid-first-name"
            type="text"
            onChange={titleChange}
            value={text[activeLanguage]}
          />
        </div>
        <div
          className="bg-blue-light border-blue-darker ml-4 cursor-pointer flex items-center justify-center py-6 rounded text-center text-white w-10"
          onClick={() => setShowOptions(!showOptions)}
        >
          <svg
            className={`fill-current h-4 w-4 ${showOptions ? 'rotate-180' : ''}`}
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 20 20"
          >
            <path d="M9.293 12.95l.707.707L15.657 8l-1.414-1.414L10 10.828 5.757 6.586 4.343 8z" />

          </svg>
        </div>
      </div>
      { showOptions && (
        <div>
          <div className="flex justify-between sm:flex-wrap w-full xs:flex-wrap">
            {/* Double Color Form */}
            <div className="md:mr-4 xl:mr-4 lg:mr-4 xl:w-1/4 lg:w-1/4 w-full">
              <label
                className="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2"
                htmlFor="grid-first-name"
              >
                Text Color
              </label>
              <div className="relative">
                <input
                  className="appearance-none uppercase block w-full bg-gray-200 text-gray-700 border border-red-500 rounded py-3 px-4 mb-3 leading-tight focus:outline-none focus:bg-white"
                  id="grid-first-name"
                  type="text"
                  name="textColor"
                  onChange={handleColorInput}
                  value={color}
                />
                <input
                  className="absolute bg-transparent flex h-full items-center p-1 right-0 text-gray-700 top-0"
                  name="textColor"
                  type="color"
                  onChange={handleColorInput}
                  value={color}
                />
              </div>
            </div>
            { slider ? null : (
              <div className="md:mr-4 xl:mr-4 lg:mr-4 xl:w-1/4 lg:w-1/4 w-full">
                <label
                  className="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2"
                  htmlFor="grid-last-name"
                >
                  Background Color
                </label>
                <div className="relative">
                  <input
                    className="appearance-none uppercase block w-full bg-gray-200 text-gray-700 border border-gray-200 rounded py-3 px-4 leading-tight focus:outline-none focus:bg-white focus:border-gray-500"
                    id="grid-last-name"
                    type="text"
                    name="backgroundColor"
                    onChange={handleColorInput}
                    value={bgColor}
                  />
                  <input
                    className="absolute bg-transparent flex h-full items-center p-1 right-0 text-gray-700 top-0"
                    name="backgroundColor"
                    type="color"
                    onChange={handleColorInput}
                    value={bgColor}
                  />
                </div>
              </div>
            )}
            {/* End */}
            <div className="md:mr-4 xl:mr-4 lg:mr-4 xl:w-1/4 lg:w-1/4 w-full">
              <label className="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2" htmlFor="grid-state">
                Head Title
              </label>
              <div className="relative">
                <select
                  className={SELECT_CLASS}
                  value={isHeadTitle ? 'true' : 'false'}
                  onChange={e => setIsHeadTitle(e.target.value === 'true')}
                >
                  <option value={false}>Default</option>
                  <option value>Yes</option>
                </select>
                <DownCaret />
              </div>
            </div>
            <div className="mr-4 lg:w-1/4 xl:w-1/4 w-full">
              <label className="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2" htmlFor="grid-state">
                Text Align
              </label>
              <div className="relative">
                <select
                  className={SELECT_CLASS}
                  value={textAlign}
                  onChange={e => setTextAlign(e.target.value === 'false' ? false : e.target.value)}
                >
                  <option value={false}>Default</option>
                  <option value="left">Left</option>
                  <option value="center">Center</option>
                  <option value="right">Right</option>
                </select>
                <DownCaret />
              </div>
            </div>
            <div className="lg:w-1/4 xl:w-1/4 w-full">
              <label className="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2" htmlFor="grid-state">
                Style
              </label>
              <div className="relative">
                <select
                  className={SELECT_CLASS}
                  value={style}
                  onChange={e => setStyle(e.target.value)}
                >
                  {STYLE_OPTIONS.map(styleOption => <option value={styleOption.value} key={styleOption.value}>{styleOption.label}</option>)}
                </select>
                <DownCaret />
              </div>
            </div>
          </div>
          * To remove the background color just write transparent
        </div>
      )}
    </div>
  );
};

TitleLineH1.propTypes = {
  activeLanguage: PropTypes.string.isRequired,
  handlerSetComponents: PropTypes.func.isRequired,
  components: PropTypes.arrayOf(PropTypes.shape()).isRequired,
  id: PropTypes.string.isRequired,
  languages: PropTypes.arrayOf(PropTypes.string).isRequired,
  reusableComponent: PropTypes.shape(),
  slider: PropTypes.bool,
};
TitleLineH1.defaultProps = {
  reusableComponent: null,
  slider: false,
};

export default TitleLineH1;
